export const METADATA_PREFIX = "symbiosis:";

export const DEFAULT_CONNECTION_NAME = "Default";
